export const searchMode: Record<"DATE" | "RESORT", string> = {
  //0:不可選   1:可選
  DATE: "date",
  RESORT: "resort",
};
